






























































































import {Vue, Component, Prop, PropSync, Watch} from 'vue-property-decorator'
import { DatePickerWings, SelectWings, InputWings } from "wings-ui-components";
import { Action, Getter } from "vuex-class";
import { TemplateParamValue } from "@/store/templates/types";

@Component({ components: { DatePickerWings, SelectWings, InputWings } })
export default class AdditionalParamsCard extends Vue {
  @Prop({ required: true }) transport!: string;
  @PropSync("params") templateParams!: TemplateParamValue[];

  @Action("getTemplateParams") actionGetTemplateParams: any;
  @Getter("templateParams") templateParamsList: any;

  selected: any[] = [];

  loadTemplateParams() {
    this.actionGetTemplateParams({ transport: this.transport.toLowerCase() });
  }

  created() {
    this.loadTemplateParams();
  }

  addParam() {
    this.templateParams.push({ template_params_list_id: null, value: '' });
  }

  removeSelected() {
    const selectedIds = this.selected.map(item => item.template_params_list_id);
    this.templateParams = this.templateParams.filter(param => !selectedIds.includes(param.template_params_list_id));
    this.selected = [];
  }

  selectedKey(index: number) {
    const item = this.templateParams[index];
    const defaultVal = {
      id: null,
      type: 1,
      conditions: {
        stringMinLength: 0,
        stringMaxLength: 255,
        numberMinValue: 0,
        numberMaxValue: 10000,
        enum: []
      }
    };
    if (!item || item.template_params_list_id == null) return defaultVal;
    return this.templateParamsList.find((key: any) => key.id === item.template_params_list_id) || defaultVal;
  }

  filteredKeysList(currentIndex: number) {
    const selectedIds = this.templateParams
        .filter((_, i) => i !== currentIndex)
        .map(p => p.template_params_list_id)
        .filter(id => id !== null);
    return this.templateParamsList.filter((key: any) => !selectedIds.includes(key.id));
  }

  onSelect(selectedItems: any[]) {
    this.selected = selectedItems;
  }

  onKeyChange(index: number) {
    const item = this.templateParams[index];
    if (!item.template_params_list_id) item.value = '';
  }

  get validationRules() {
    return this.templateParams.map((item, index) => {
      const key = this.selectedKey(index);
      if (!key || key.id == null) return 'required';

      if (key.type === 1) {
        const min = key.conditions?.stringMinLength || 0;
        const max = key.conditions?.stringMaxLength || 255;
        return `required|min:${min}|max:${max}`;
      }

      if (key.type === 2) {
        const min = key.conditions?.numberMinValue ?? 0;
        const max = key.conditions?.numberMaxValue ?? 1000000;
        return `required|numeric|min_value:${min}|max_value:${max}`;
      }

      return 'required';
    });
  }
}
